import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  completePurchaseButton: {
    id: 'modules.BuyProduct.SummaryStep.completePurchaseButton',
    defaultMessage: 'Complete purchase • {priceComponent}'
  },
  termsOfPurchase: {
    id: 'modules.BuyProduct.SummaryStep.link',
    defaultMessage: 'terms of purchase'
  },
  change: {
    id: 'modules.BuyProduct.SummaryStep.changeButton',
    defaultMessage: 'Change'
  }
});
